export default class Identity {
	constructor({
		id,
		reply_to: replyTo,
		from_address: fromAddress,
	} = {}) {
		this._id = id || null;
		this._fromAddress = fromAddress || {};
		this._replyTo = replyTo || {};
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getFromAddress() {
		return this._fromAddress;
	}

	getFromEmailAddress() {
		return this._fromAddress && this._fromAddress.email;
	}

	getFromPrefixEmail() {
		let email = this._fromAddress ? this._fromAddress.email : "";

		return email.substring(0, email.lastIndexOf("@"));
	}

	getFromDomain() {
		let email = this._fromAddress ? this._fromAddress.email : "";

		return email.substring(email.lastIndexOf("@") +1);
	}

	getReplyTo() {
		return this._replyTo;
	}

	toString() {
		return `${this._fromAddress && this._fromAddress.name} <${this._fromAddress && this._fromAddress.email}>`;
	}

	getReplyToString() {
		return `${this._replyTo && this._replyTo.name} <${this._replyTo && this._replyTo.email}>`;
	}
}
